import { useMemo } from "react";
import AscButton from "../AscButton/AscButton";
import AscTable from "../AscTable/AscTable";
import styles from "./AscInvoicePreview.module.scss";
import AscParagraph from "../AscTypography/AscParagraph/AscParagraph";
import dayjs from "dayjs";
import AscHeading from "../AscTypography/AscHeading/AscHeading";

export enum DataInvEnum {
  InvID = "InvID",
  date = "date",
  credits = "credits",
}

type DataTicket = {
  [DataInvEnum.InvID]: string | number;
  [DataInvEnum.date]: string | any;
  [DataInvEnum.credits]: string;
};

export interface AscInvoicePreviewProps {
  dataInvoices: any[];
  seeFullHistory?: () => void;
}

export default function AscInvoicePreview({
  dataInvoices,
  seeFullHistory,
}: AscInvoicePreviewProps) {
  const determineDay = (day: any) => {
    const presentDay = dayjs().format("DD MMMM YYYY");
    const date = dayjs(day).format("DD MMMM YYYY");

    if (presentDay == date) {
      return "Today";
    } else {
      return date;
    }
  };

  const tableData: DataTicket[] = useMemo(
    () => [...dataInvoices],
    [dataInvoices]
  );

  const tableColumns = useMemo(() => {
    const columns = [
      {
        Header: () => {
          return (
            <AscParagraph className={styles.headName}>
              {determineDay(dataInvoices[0]?.date)}
            </AscParagraph>
          );
        },
        accessor: DataInvEnum.InvID,
        Cell: (cell: { value: any }) => {
          return (
            <AscParagraph className={styles.date}>
              {cell.value.length > 4 ? `#${cell.value.slice(-4)}` : cell.value}
            </AscParagraph>
          );
        },
      },

      {
        accessor: DataInvEnum.date,
        Cell: (cell: { value: any }) => {
          return (
            <AscParagraph className={styles.date}>
              {dayjs(cell.value).format("H:m A")}
            </AscParagraph>
          );
        },
      },

      {
        accessor: DataInvEnum.credits,
        Cell: (cell: { value: any }) => {
          return (
            <AscParagraph className={styles.credits}>
              {cell.value} credits
            </AscParagraph>
          );
        },
      },
    ];

    return columns;
  }, [tableData]);

  return (
    <div className={styles.ground}>
      <AscHeading className={styles.header}>Invoice history</AscHeading>
      <AscTable
        tHead={styles.tHead}
        tBody={styles.tBody}
        tH={styles.tH}
        tD={styles.tD}
        tHeadRow={styles.tHeadRow}
        pureCellFlow={styles.pureCellFlow}
        tBodyValue={styles.tBodyValue}
        className={styles.table}
        tableColumns={tableColumns}
        tableData={tableData}
        showHeader={true}
        showPagination={false}
      />

      <AscButton
        className={styles.button}
        fullWidth={true}
        onClick={seeFullHistory}
      >
        See full history
      </AscButton>
    </div>
  );
}
